/**
 * Get the profile picture URL with a default fallback
 * @param profilePictureUrl - The user's profile picture URL (can be null or undefined)
 * @returns The profile picture URL or the default avatar path
 */
export function getProfilePictureUrl(profilePictureUrl: string | null | undefined): string {
  return profilePictureUrl || '/default-avatar.svg';
}

